var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"vca-table-nav bottom-navigation"},[_c('td',{staticClass:"text-right vca-table-nav-cell",attrs:{"colspan":_vm.colspan}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("table.page.size"))+": "),_c('div',{staticClass:"vca-border main-color editable vca-page-all"},[_vm._v(" "+_vm._s(_vm.pg.listLength)+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }